import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MenuCollapsed = _resolveComponent("MenuCollapsed")
  const _component_IconAsButton = _resolveComponent("IconAsButton")
  const _component_MenuExpanded = _resolveComponent("MenuExpanded")
  const _component_SmoothResize = _resolveComponent("SmoothResize")
  const _component_Mask = _resolveComponent("Mask")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["navbar-container", {overlay: $options.overlay}])
  }, [
    _createVNode(_component_SmoothResize, {
      class: "navbar-resize",
      horizontal: "",
      active: $options.collapsed ? 'collapsed' : 'expanded',
      onMouseenter: $options.onMouseEnter,
      onMouseleave: $options.onMouseLeave
    }, {
      collapsed: _withCtx(() => [
        _createVNode(_component_MenuCollapsed, {
          items: $options.items,
          onClick: _cache[0] || (_cache[0] = $event => ($options.overlay && ($data.open = true)))
        }, null, 8 /* PROPS */, ["items"])
      ]),
      expanded: _withCtx(() => [
        _createVNode(_component_MenuExpanded, {
          pinned: $options.pinned,
          "onUpdate:pinned": _cache[1] || (_cache[1] = $event => (($options.pinned) = $event)),
          items: $options.items,
          "show-pin": !$options.overlay,
          onShow: $options.allowCollapse
        }, _createSlots({ _: 2 /* DYNAMIC */ }, [
          ($options.overlay)
            ? {
                name: "collapse",
                fn: _withCtx(() => [
                  _createVNode(_component_IconAsButton, {
                    icon: "x-close",
                    size: "2rem",
                    onClick: _withModifiers($options.close, ["stop"])
                  }, null, 8 /* PROPS */, ["onClick"])
                ]),
                key: "0"
              }
            : undefined
        ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["pinned", "items", "show-pin", "onShow"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["active", "onMouseenter", "onMouseleave"]),
    ($options.overlay)
      ? (_openBlock(), _createBlock(_component_Mask, {
          key: 0,
          show: $data.open,
          class: "tablet-mask",
          onClick: $options.close
        }, null, 8 /* PROPS */, ["show", "onClick"]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}